export default {
  Token: {
    token: '代币',
    trending: '行情',
    graduated: '已经发射',
    quickBuy: '快速买入',
    filterRisk: '过滤风险',
    select: '选择',
    liquidity: '流动性',
    marketCap: '市值',
    holder: '持有',
    price: '价格',
    all: '全部',
    devHold: 'DEV 未清仓',
    devSellAll: 'DEV 清仓',
    devBunt: 'DEV 烧币',
    action: '操作',
    holding: '持仓',
    buy: '买',
    chg: '涨跌幅',
    balance: '余额',
    '7D': '7天',
    '30D': '30天',
    deposit: '充值',
    amount: '数量',
    vol: '交易额',
    mc: '市值',
    watchList: '关注',
    newCreations: '新创建',
    aboutToGraduate: '即将打满',
    status: '状态',
    migrating: '迁移中',
    signals: '信号',
    treasures: '榜单',
  },
  Base: {
    nodata: '没有数据...',
    depositFund: '充值资产',
    depositFundText: '扫描二维码或者复制地址以充值资产',
    depositFundTextTips: '（仅接受{{chain}}上的资产）',
    withdrawFund: '提取资产',
    withdraw: '提取',
    available: '可用：',
    all: '全部',
    enterAddress: '输入地址',
    confirmWithdraw: '确认提取',
    withdrawTips: '请确认是否转账。错误的地址将无法恢复。',
    sendTips: '您将把 <0>{{amount}}</0> <0>{{symbol}}</0> 发送到以下地址',
    share: '分享',
    enterAmount: '请输入数量',
    pleLogin: '请先登录',
    cancel: '取消',
    copyAddress: '复制地址',
    login: '登录',
    copySuccessful: '复制成功',
    noPermission: '没有权限',
    invalidAddressTips: '请输入 EVM(Solana) 地址',
  },
  Address: {
    '30DPnL': '30天盈亏',
    '7DPnL': '7天盈亏',
    last7DPnl: '最近7天盈亏',
    last30DPnl: '最近30天盈亏',
    share: '分享',
    profit: '利润',
    distribution: '盈利分布',
    winRate: '胜率',
    solBalance: 'SOL 余额',
    totalPnL: '总利润',
    unrealizedProfit: '未实现利润',
    pnL: '利润',
    '7dToastCost': '7天总花费',
    '7dTokenAvgCost': '7天平均花费',
    '7dTokenRealizedAvgCost': '7天代币平均利润',
    '7dBuyTokens': '7天代币买入数',
    '30dToastCost': '30天总花费',
    '30dTokenAvgCost': '30天平均花费',
    '30dTokenRealizedAvgCost': '30天代币平均利润',
    '30dBuyTokens': '30天代币买入数',
    recentPnl: '最近收益',
    holdings: '持仓',
    activity: '活动',
    history: '记录',
    '7dRealizedProfit': '7天已实现收益',
    '30dRealizedProfit': '30天已实现收益',
    token: '代币',
    totalProfit: '总收益',
    tokenLastActive: '代币/最后活动',
    unrealized: '未实现利润',
    realizedProfit: '已实现利润',
    balance: '余额',
    position: '仓位',
    bought: '买入',
    sold: '卖出',
    avg: '平均',
    '30DTxs': '30天交易数',
    hideSmallAssets: '隐藏小额资产',
    hideSellOut: '隐藏全部卖出',
    type: '类型',
    total: '总额',
    amount: '数量',
    price: '价格',
    time: '时间',
    deposit: '充值',
    withdraw: '提取',
    from: '从',
    to: '到',
  },
  Header: {
    revokeDelegate: '撤销委托',
    approveDelegate: '授权委托',
    logout: '登出',
    exportWallet: '导出錢包',
    referral: '邀请',
    watchList: '关注',
    language: '语言',
    search: '搜索',
    searchHistory: '搜索历史',
    enterContractToken: '输入合约/代币',
    dayTrending: '24小时行情',
    darkMode: '黑夜模式',
    advanced: '高级设置',
    deposit: '充值',
    withdraw: '提取',
  },
  SmartTag: {
    all: '全部',
    bargainHunter: '抄底大师',
    topEscapeMaster: '逃顶大师',
    heavyPositionsMaster: '重仓少出手',
    pumpfunHunter: '内盘高盈利',
    diamondHand: '钻石手',
    alwaysWrong: '反指',
    newAddress: '新地址',
  },
  Tabbar: {
    token: '代币',
    smart: '聪明钱',
    trade: '交易',
    account: '用户',
    signal: '信号',
    watchList: '关注',
  },
  Trade: {
    balanceD: '余额：',
    slippageD: '滑点：',
    priorityFeeD: '优先费：',
    setting: '设置',
    auto: '自动',
    mevProtection: 'MEV保护',
    TakeProfitAndStopLoss: '止盈止损',
    insufficientBalanceRecharge: '余额不足请充值',
    amountCannotBeZero: '数量不能为0',
    enterAmount: '请输入数量',
    insufficientBalance: '余额不足，请充值',
    insufficientBalanceNoGas: '余额不足以支Gas费用',
    buy: '买',
    sell: '卖',
    market: '市价',
    limit: '限价',
    reservedBalanceTooFew: 'SOL余额不足以支付Gas费用',
    quantity: '数量',
    value: '数值',
    allTimeGains: '所有时间收获',
    currentPNL: '当前利润',
    position: '收益',
    myOrder: '我的订单',
    activity: '活动',
    unrealized: '未实现利润',
    realizedProfit: '已实现利润',
    BoughtAndAvg: '已购买/平均价',
    totalProfit: '总利润',
    balance: '余额',
    type: '类型',
    price: '价格',
    total: '总额',
    amount: '数量',
    maker: '交易者',
    time: '时间',
    slippageTips: '滑点不能大于30%',
    priorityFeeTips: '优先费不能大于0.2 SOL',
    never: '从不',
    '10min': '10 分钟',
    '1hour': '1 小时',
    '1day': '1 天',
    '3day': '3 天',
    '7day': '7 天',
    '30day': '30 天',
    cancel: '取消',
    createWhen: '创建快照',
    targetPrice: '触发价',
    status: '状态',
    condition: '触发条件',
    priceIncrease: '价格上涨',
    priceDrop: '价格下跌',
    limitPriceNotZero: '挂单价格不能为0',
    limitPriceNotEmpty: '挂单价格不能为空',
    limitAmountNotGtBalance: '挂单数量不能大于余额',
    totalPriceNotLt10: '挂单总价不能小于10USDT',
    priceInUSD: 'USD 本位',
    expiry: '有效期',
    dropChgNoGte100: '下跌幅度不能大于等于100%',
    active: '运行',
    success: '成功',
    expiration: '过期时间',
    canceled: '已取消',
    insufficientFunds: '资金不足',
    buyIn: '买入',
    sellOut: '卖出',
    mcap: '市值',
    liq: '流动性',
    '24hVol': '24H交易额',
    holders: '持有者',
    holding: '持仓',
    orders: '订单',
    chart: '图表',
    info: '信息',
    marketInfo: '市场信息',
    liquidity: '流动性',
    marketCap: '市值',
    createdAt: '创建时间',
    '24hVolume': '24小时交易额',
    volumes: '交易额',
    makers: '交易数',
    buys: '买入数',
    sells: '卖出数',
    buyVol: '买入额',
    sellVol: '卖出额',
    buyers: '买入数',
    sellers: '卖出数',
    login: '登录',
    edit: '编辑',
    slippageLowTips: '滑点过低可能导致交易失败, 建议设置在 0.1% ~ 80% 之间.',
    slippageZeroTips: '滑点不应为 0%, 建议设置在 0.1% ~ 80% 之间.',
    slippageExceedTips: '滑点不应超过 80%, 建议设置在 0.1% ~ 80% 之间.',
    solPriorityFeeLowTips: '优先级费过低可能导致交易执行过慢, 建议设置在 0.012 ~ 2 SOL 之间.',
    solPriorityFeeExceedTips: '优先级费不应超过 2 SOL, 建议设置在 0.012 ~ 2 SOL 之间.',
    bscGasFeeLowTips: 'Gas 费过低可能导致交易执行过慢, 建议设置在 1 ~ 20 Gwei 之间',
    bscGasFeeExceedTips: 'Gas 费过高可能导致高额费用, 建议设置在 1 ~ 20 Gwei 之间',
    advancedSetting: '高级设置',
    slippage: '滑点',
    priorityFee: '优先费',
    confirm: '确认',
    AntiMEV: '防MEV',
    close: '关闭',
    percent: '百分比',
    sellAll: '清仓',
    authorize: '授权',
    gasFee: 'Gas费',
  },
  Smart: {
    smartMoney: '聪明钱',
    notification: '通知',
    users: '用户',
    quickBuy: '快速买入',
    '7d': '7天',
    '30d': '30天',
    '7dWinRate': '7天胜率',
    '7dRoi': '7天收益率',
    '7dPnL': '7天收益',
    '30dWinRate': '30天胜率',
    '30dRoi': '30天收益率',
    '30dPnL': '30天收益',
  },
  Follow: {
    follow: '关注',
    smartMoney: '聪明钱',
    tokens: '代币',
    vol: '交易额',
    mc: '市值',
    chg: '涨跌幅',
    price: '价格',
  },
  Referral: {
    referralText: '赚取你邀请人交易手续费的 <0>30%</0> 以及他们邀请人交易手续费的 <0>5%</0>',
    invitationLink: '邀请链接',
    availableRewards: '可提取奖励',
    claimedRewards: '已提取奖励',
    totalReferrals: '邀请人数',
    points: '积分',
    myReferrals: '我的推荐',
    withdrawTips: '返佣大于 $50 时才能提现',
    pointTips: '交易 $1 获得 100 积分, 积分未来可以用于兑换平台更多增值服务或潜在的空投.',
    wallet: '资金账户',
    volume: '交易额',
    rewards: '奖励',
    referralOverview: '推荐总览',
    withdraw: '提取',
    ambassadorProgram: '大使计划',
    ambassadorProgramTips: '申请大使计划, 赚取更高返佣',
    apply: '申请',
  },
  Account: {
    deposit: '存款',
    withdraw: '取款',
    holding: '持仓',
    activity: '活动',
    history: '历史',
    type: '类型',
    time: '时间',
    token: '代币',
    value: '金额',
    price: '价格',
    all: '全部',
    buy: '买入',
    sell: '卖出',
    unrealizedProfit: '未实现利润',
    balance: '余额',
    to: '到',
    from: '从',
    maker: '交易者',
    address: '地址',
  },
  Signal: {
    price: '价格',
    mc: '市值',
    liquidity: '流动性',
    holders: '持有者',
    alert: '提醒',
    now: '现在',
    safe: '安全',
    noMint: '铸造丢弃',
    blackList: '黑名单',
    burnt: '烧池子',
    totalProfit: '总盈利',
    bought: '买入金额',
    time: '时间',
    alertMaxChg: '第一次提醒后的最大增幅为<0>{{symbol}}</0><0>{{value}}</0>',
    wallet: '钱包',
    setting: '设置',
    mergeSignals: '合并信号',
    mevProtection: 'MEV 保护',
    slippage: '滑点',
    auto: '自动',
    priorityFee: '优先费',
    amountQuickBuy: '快速购买金额（{{symbol}}）',
    percentQuickSell: '快速出售百分比',
    cancel: '取消',
    confirm: '确认',
    top10: 'Top 10',
    alertTips: '第 <0>{{count}}</0> 次提醒在 <0>{{time}} </0>',
    token: '代币',
    alertTime: '提醒次数',
    maxIncrease: '最大涨幅',
    notBalance: '余额不足',
    tutorial: '辅导',
    howItWorks: '如何工作',
    signalFilter: '信号过滤',
    signalAlertTimes: '信号提醒次数',
    reset: '重置',
    apply: '应用',
    pushTimesTips: '该 meme 的第 <0>{{ordinal}}</0> 次提醒',
    search: '搜索',
    risk: '风险',
    openSource: '合约开源',
    honeypot: '蜜罐',
    renounced: '合约弃权',
    gasFee: 'Gas费',
  },
};
